import { I18n } from 'react-redux-i18n';

export default {
  watchListType: {
    COMPANY_GROUP: 'CompanyGroup',
    CUSTOM: 'Custom',
  },

  watchList: {
    WATCH_LIST_ID: 'watchListId',
    TEXT: 'text',
    CODE: 'code',
    TYPE_CODE: 'typeCode',
  },

  defaultWatchList: 'VN30',
  defaultWatchListId: '35',
  overviewDeceptiveInterval: 1000 * 31,
  abnormalityDeceptiveInterval: 1000 * 31,
  cancelledDeceptiveInterval: 1000 * 31,
  pressingDeceptiveInterval: 1000 * 31,
  aggressiveDeceptiveInterval: 1000 * 31,
  closingDeceptiveInterval: 1000 * 31,

  itemPerPage: 50,
  itemAll: {
    watchListId: 0,
    typeCode: '',
  },
};
